module.exports = ".radio-button-list{\r\n    margin-left: 150px;\r\n}\r\n\r\n.radio-button-list .form-check-label {\r\n    font-size: 15px;\r\n}\r\n\r\n.form-check-input{\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-procurement-details/land-procurement-details.component.css
// module id = ./src/app/landprocurement/land-procurement-details/land-procurement-details.component.css
// module chunks = main